module.exports = __webpack_public_path__ + "static/media/job-4.d6ead1f1.png";